import React, { useState, } from 'react';
import { Button, Result, Space, Row, Typography, } from 'antd';
import { LaptopOutlined, TableOutlined, } from '@ant-design/icons';
import { Modal } from '../../../UI/Modal/Modal.component';
import { getPath } from '../../../../services/StationService';
import { useApp } from '../../../../context/app-context';
import { Restricted } from '../../../UI/Restricted.component';
import { useMessage } from '../../../UI/MessageProvider';

const { Text } = Typography;

export const DeviceButtonGroup = ({serialNum, status, type, shape, size, hostTable, ant, winbox, config, eps, ...props}) => {

    const TEMP_TEST_USERNAME = 'agerman';

    const { state: {user} } = useApp();
    const message = useMessage();

    const [displayWinbox, setDisplayWinbox] = useState(false);
    const [port, setPort] = useState(0);

    const CLIENT_SETTINGS = {
        service: '172.17.1.21',
        vpn: 'remotedevices.avalan.com',
        vpn2: '172.17.1.20',
    };

    const handleANTButton = () => {
        let data = { serialNum: serialNum, port: -2 }

        getPath(data).then(function( response ) {
            let url = "https://" + CLIENT_SETTINGS.vpn + ":" + response[0];
            let window1 = window.open('', '_blank');
            setTimeout(function () {
				window1.location = url + "";
			}, 1000);
        })
    }

    const handleCommanderButton = () => {
        let data = { serialNum: serialNum, port: 14443, trailURL: "/ConfigClient.html"}


        getPath(data).then(function( response ) {
            let url = "https://" + CLIENT_SETTINGS.vpn + ":" + response[0] + data.trailURL;
            let window1 = window.open('', '_blank');
            setTimeout(function () {
				window1.location = url + "";
			}, 1000);
        })
    }


    const handleEPSButton = () => {
        let data = { serialNum: serialNum, port: 8080, trailURL: "/eps/"}

        getPath(data).then(function( response ) {
            let url = "http://" + CLIENT_SETTINGS.vpn + ":" + response[0] + data.trailURL;
            let window1 = window.open('', '_blank');
            setTimeout(function () {
				window1.location = url + "";
			}, 1000);
        })
    }


    const handleWINBOX = () => {
        let data = { serialNum: serialNum, port: -1 }

        getPath(data).then(function( response ) {
            setPort(response[0]);
            setDisplayWinbox(true)
        })
    }
    
    const copyText = () => {
        navigator.clipboard.writeText(CLIENT_SETTINGS.vpn + ":" + port);
        message.success('Copied', 1.5);
    }

    const deviceOfflineNotification = () => message.error(`Device ${serialNum} is offline`);

    return (
        <>
            <Space>
                {/* { hostTable && <Button type={status && 'primary'} shape={shape} size={size} icon={<TableOutlined/>} {...props}>Host Table&nbsp;</Button> } */}
                
                <Restricted to='device.commander'>
                    { (config || eps) &&
                        <Space>
                            { config && <Button type={status && 'primary'} shape={shape} size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleCommanderButton()}>Commander Config</Button> }
                            { eps && <Button type={status && 'primary'} shape={shape} size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleEPSButton()}>Commander EPS</Button> }
                        </Space>
                    }
                </Restricted>
                
                {/* ---- COMMENT TO ENABLE TESTING ---- */}
                {/* { ant && <Button type={status && 'primary'} shape={shape} size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleANTButton()}>ANT</Button> }
                { (winbox && superUser) && <Button type={status && 'primary'} shape={shape}  size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleWINBOX()}>WINBOX</Button> } */}
                
                
                {/* ---- COMMENT TO DISABLE TESTING ---- */}
                {
                    (user.username !== TEMP_TEST_USERNAME) ? 
                        <>
                            { ant && 
                                <Restricted to='device.ant'>
                                    <Button type={status && 'primary'} shape={shape} size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleANTButton()}>ANT</Button> 
                                </Restricted>
                            }
                            { winbox && 
                                <Restricted to='device.winbox'>
                                    <Button type={status && 'primary'} shape={shape}  size={size} icon={<LaptopOutlined/>} {...props} onClick={() => !status ? deviceOfflineNotification() : handleWINBOX()}>WINBOX</Button> 
                                </Restricted>    
                            }
                        </>
                    :
                        <>
                            { ant && 
                                <Restricted to='device.ant'>
                                    <Button type='primary' shape={shape} size={size} icon={<LaptopOutlined/>} {...props} onClick={() => handleANTButton()}>ANT</Button> 
                                </Restricted>
                            }
                            { winbox && 
                                <Restricted to='device.winbox'>
                                    <Button type='primary' shape={shape}  size={size} icon={<LaptopOutlined/>} {...props} onClick={() => handleWINBOX()}>WINBOX</Button> 
                                </Restricted>
                            }
                        </>
                }
            
            </Space>

            

            <Modal
                visible={displayWinbox}
                setVisible={setDisplayWinbox}
                actionGroup={false}
                width={450}
                >
                <Result
                    title='WINBOX'
                    subTitle= <Text>Device <strong>{serialNum}</strong> is now accessible at:<br/><Button style={{border: 0, color: 'var(--primary-color)'}}><strong>{CLIENT_SETTINGS.vpn}:{port}</strong></Button></Text>
                    style={{padding: 0}}
                    extra={
                        <Row justify='end'>
                            <Space>
                                <Button type='default' onClick={() => copyText()}>Copy Text</Button>
                                <Button type="primary" onClick={() => setDisplayWinbox(false)}>OK!</Button>
                            </Space>
                        </Row>
                    }
                />
            </Modal>
        </>
    );
}

DeviceButtonGroup.defaultProps = {
    type: 'primary', 
    shape: 'default', 
    size: 'default', 
    ant: false, 
    winbox: false,
    config: false,
    eps: false,
    hostTable: false,
    status: false,
}